import React from 'react';
import './FooterListItem.scss';

export default function FooterListsItem({
  item,
  active,
  setActiveFooterIndex,
  className = '',
}) {
  return (
    <div
      className={`footerListItem ${className}`}
      onClick={setActiveFooterIndex}
    >
      <div
        style={{
          border: `3px solid ${active ? '#2F80ED' : '#dfe5e9'}`,
          background: `${active ? '#2F80ED' : '#dfe5e9'}`,
        }}
      ></div>
      <p className='mb-0 mt-1'>
        {item}
      </p>
    </div>
  );
}
